import { render } from "./LanguageChoice.vue?vue&type=template&id=08c98c71&scoped=true"
const script = {}

import "./LanguageChoice.vue?vue&type=style&index=0&id=08c98c71&lang=scss&scoped=true"

import exportComponent from "C:\\AQRepo\\customermanagedinspection_fe-brands-kra-norden\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08c98c71"]])

export default __exports__